import React, { useState, useEffect, Fragment } from 'react';

import ListingCard from './ListingCard.js';
import AddListingModal from './AddListingModal.js';


import useAuthUser from 'react-auth-kit/hooks/useAuthUser';


import { useNavigate } from 'react-router-dom';


export default function ListingCards(props) {
    
    const [listings, setListings] = useState([]);

    const [filterName, setFilterName] = useState('');
    const [filterCircuit, setFilterCircuit] = useState('');
    const [filterState, setFilterState] = useState('');

    const [uniqueStates, setUniqueStates] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const [showAdd, setShowAdd] = useState(false);

    const authUser = useAuthUser();

    const navigate = useNavigate();


    useEffect(() => {


        const fetchData = async() => {
            const response = await fetch('/api/listing/index?filterName='+ `${filterName}` + '&filterCircuit=' + `${filterCircuit}` + '&filterState=' + `${filterState}`);
            const jsonData = await response.json();

            setListings(jsonData);
        };
        //.then( async(resp) => { 
        //      setListings(await resp.json());
        //})
        //.then( data => {
          

          //const uniqueStatesTemp = new Set(data.map(item => item.listingState));
          //setUniqueStates([...uniqueStatesTemp]);

          //console.log(uniqueStates);
        //})

        fetchData();
        //const uniqueSet = new Set(listings.map((item) => item.listingState)); // Replace 'valueField' with the field you want to extract
        //setUniqueStates([...uniqueSet]);

    }, [filterName, filterCircuit, filterState]);


    useEffect(() => {
        // Extract unique values from fetched data

        //console.log("Is Loading : " + isLoading);

        if ( isLoading && listings.length > 0)
        {
          //  console.log('Here loading : ' + isLoading);
            const uniqueSet = new Set(listings.map((item) => item.listingStateProv)); 
            setUniqueStates([...uniqueSet].sort());
          //  console.log(uniqueStates);
            setIsLoading(false);
            
        }

      }, );
    


    function handleFilterNameChange(e) 
    {
        setFilterName(e.target.value);
    }

    function handleFilterCircuitChange(e) 
    {
        setFilterCircuit(e.target.value);
    }

    function handleFilterStateChange(e) 
    {
        setFilterState(e.target.value);
    }

    function handleAddClick()
    {

        if (authUser?.profile.profileId)
        {
            setShowAdd(true);
        }
        else
        {
            console.log("Not logged in");
            navigate('/login'); 
        }
    }

    const addedListing = (addList) => {
        if (addList && listings) {
            let clone = [...listings];
            clone.push(addList);
            setListings([...clone]);
        }
        setShowAdd(false);
    };
    
    return (
        <>

        <div className="row">
                <div
                  className="align-items-center justify-content-left col-4"
                  style={{ height: "5vh" }}
                >
                  <button className="btn btn-primary" onClick={handleAddClick}>
                    Add Listing
                  </button>
                    <AddListingModal show={showAdd} close={() => setShowAdd(false)} listItem={listings.listItem} addedListing={addedListing}  />
                  
                </div>
                <div className="align-items-center col-8 pt-2 pe-4">
                    <p className="text-end ">Need to add a circuit, contact <a href="mailto:listings@sidekick.events">Support</a></p>
        
                </div>
        </div>
        
        

        <div className="row d-flex g-3 pt-3">
            <div className="col-12">
                <h4 className="d-flex justify-content-between align-items-center mb-2">
                    <span className="">{listings.length} Tournaments</span>
                </h4>
            </div>
            <div className="row">
                <div className="col-xl-4 col-lg-6 col-md-6 col-6">
                    <div className="form-floating">
        
                        <input
                        type="text"
                        id="filterName"
                        
                        name="filterName"
                        className="form-control"
                        onChange={handleFilterNameChange}
                        /* onChange={(e) => { 
                            setFilterName(e.target.value);
                            //setFilterName({ ...filterName, [e.target.name]: e.target.value} ); //{ setFilterName(e.target.value);
                            getData();
                    
                    }                     
                    }*/
                        />
                        <label htmlFor="filterName">Filter by name:</label>
                    </div>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                    <div className="form-floating">
        
                        <select className="form-select" id="listingCircuit" 
                        name="listingCircuit" 
                        //value={listItem.listingCircuit ? listItem.listingCircuit : "OTHER"} 

                        onChange={handleFilterCircuitChange}
                        onSelect={handleFilterCircuitChange}
                        /*
                        onChange={(e) => {
                                        setFilterCircuit(e.target.value);
                                        getData();
                            }
                        }
                        */
                        >
                            <option defaultValue={'ALL'} value="ALL">All</option>

                            <option value="ATA">ATA</option>
                            <option value="GTMA">GTMA</option>
                            <option value="NASKA">NASKA</option>
                            <option value="OPEN">OPEN</option>
                            <option value="OTHER">OTHER</option>
                            <option value="TKO">TKO</option>
                            <option value="UFAF">UFAF</option>
                        </select>
                        <label htmlFor="listingCircuit">Circuit:</label>

                    </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3 col-3">
                    <div className="form-floating">
        
                        <select className="form-select" id="listingState" 
                        name="listingState" 
                        //value={listItem.listingCircuit ? listItem.listingCircuit : "OTHER"} 

                        onChange={handleFilterStateChange}
                        onSelect={handleFilterStateChange}
                       >
                            <option defaultValue={'ALL'} value="ALL">All</option>
                            {uniqueStates.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        
                            
                         {/*   
                            <option value="TX">TX</option>
                            <option value="WA">WA</option>
           
   {                         {uniqueStates.map(value => (
                                <option key={value} value={value}>
                                {value}
                                </option>
                            ))}
}*/}

                        </select>
                        <label htmlFor="listingState">State:</label>

                    </div>
                </div>
            </div>
            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 g-3 mb-3">
                    <>
                        {listings && listings.length > 0 ? listings.map((list, i) =>
                            <Fragment key={"listing-" + list.listingId}>
                                <ListingCard
                                    {...props}
                                    listItem = {{...list, isPreview: false}}
                                    
                                />
                            </Fragment>
                        ) : null}
                        
                    </>
            </div>
        </div>
        </>
    );

}
